import React, { Component } from 'react';
import { Row } from 'react-bootstrap';

export default class NotFound extends Component {
  /*
    This component will show if the user enters a path that does not match any of the routes.
  */

  render() {
    return (
      <Row>
        <div className="box">
          <div className="header">
            <h2> 404 </h2>
          </div>
          <p style={{ textAlign: 'center', margin: '35px' }}>
            Vennligst prøv en annen URL, eller ta kontakt med administrator.
          </p>
        </div>
      </Row>
    );
  }
}
